import ConfirmCancelControllerView from './ConfirmCancelControllerView';

export default ConfirmCancelControllerView;
